import React from 'react'
import { useOrientation } from '../../contexts/OrientationContext'
import './OrientationWarning.css'

function OrientationWarning({ children }) {
  const { isPortrait } = useOrientation()

  return (
    <div className={`orientation-wrapper ${isPortrait ? 'portrait' : ''}`}>
      {children}
    </div>
  )
}

export default OrientationWarning
